import React from "react";
import clsx from "clsx";
import useDelayedValue from "hooks/useDelayedValue";
import styles from "./Progress.module.css";

type ProgressProps = {
    delay?: number;
    duration: number;
    processedId?: number;
};

const Progress = ({ delay = 0, duration, processedId }: ProgressProps) => {
    const [processing, setProcessing] = React.useState(true);
    const delayedProcessedId = useDelayedValue(processedId, delay, processedId);

    React.useEffect(() => {
        if (!delayedProcessedId) return;

        let raf = requestAnimationFrame(() => {
            setProcessing(false);
            raf = requestAnimationFrame(() => {
                setProcessing(true);
            });
        });
        return () => cancelAnimationFrame(raf);
    }, [delayedProcessedId]);

    return (
        <div className={styles.root}>
            <div
                className={clsx(styles.bar, {
                    [styles.animate]: processing && !!delayedProcessedId,
                    [styles.process]: processing || !delayedProcessedId,
                })}
                style={
                    processing && !!delayedProcessedId
                        ? {
                              transitionDuration: `calc(${duration} * var(--tick))`,
                          }
                        : {}
                }
            ></div>
        </div>
    );
};

export default Progress;
